import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFlameRating64High = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <defs>
      <linearGradient
        id="flame-rating-64-high_svg__a"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#00E04B" />
        <stop offset="100%" stopColor="#00B0B6" />
      </linearGradient>
    </defs>
    <path
      fill="url(#flame-rating-64-high_svg__a) #00c48c"
      d="M29.96 56.973C16.646 56.495 6 45.551 6 32.121 6 18.39 17.13 7.256 30.862 7.253l.003-.136c8.023-.588 11.507-4.774 11.507-4.774s.82 2.66 1.075 6.753A29.124 29.124 0 0 0 44.8 7.69c2.032-2.293 3.63-4.864 4.479-7.69 0 0 9.095 7.746 5.778 25.069 3.2-.872 3.731-4.772 3.827-7.948 1.976 4.152 6.78 41.421-28.924 39.872v-.02z"
      opacity={0.9}
      fillRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgFlameRating64High);
export default Memo;
